// part of nuxt
import type { $Fetch, NitroFetchRequest } from "nitropack"
import UrlConfig from "@/utils/UrlConfig"
import { getErrorStatus } from "@/utils/httpStatus"

export function offerRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Returns the HTTP status of the offer-service availability endpoint.
     *
     * The endpoint has no body — its meaning is carried entirely by the status:
     *   200 → offer is live (usually a Typesense indexing lag)
     *   410 → offer existed but is deactivated/hidden/deleted
     *   404 → no offer ever existed for this UUID
     *   400 → malformed UUID
     *
     * Returns undefined when the request fails without a status (network/timeout),
     * so callers can safely fall back to the generic not-found behaviour.
     * @param tenantId targeted tenant
     * @param uuid offer UUID
     * @returns the HTTP status code, or undefined if none could be determined
     */
    async getOfferAvailability(tenantId: string, uuid: string): Promise<number | undefined> {
      try {
        await fetch(`${UrlConfig.PATH_BASE_OFFER_SERVICE}/public/offers/${uuid}/availability`, {
          method: "GET",
          headers: {
            "X-Tenant-Id": tenantId,
          },
        })
        return 200
      }
      catch (error) {
        return getErrorStatus(error)
      }
    },
  }
}
